import * as React from 'react';
import { Button } from '@cian/ui-kit';

import * as styles from './SelectionsButton.css';

export interface ISelectionsButtonProps {
  onClick: () => void;
  href: string;
}

export function SelectionsButton(props: ISelectionsButtonProps): React.JSX.Element {
  const { onClick, href } = props;

  return (
    <a href={href} title={'Подобрать другой ЖК'} className={styles['button']} onClick={onClick}>
      <Button theme={'fill_primary'} size={'XS'}>
        Подобрать другой ЖК
      </Button>
    </a>
  );
}
